import { useState } from "react";
import useFetch from "../../../../hooks/useFetch";
import { sortByKey } from "../../utils/string";

export default function useDifficultyReport() {
  const { request, loading } = useFetch();
  const [data, setData] = useState([]);

  const fetchData = async (url) => {
    const res = await request(url);
    if (res?.data) {
      const mapped = res.data.questionsDifficultyStats.map((item) => ({
        Subject: item._id.name,
        Easy: item.easy,
        Intermediate: item.intermediate,
        Difficult: item.hard,
      })).filter(item => item?.Easy + item?.Intermediate + item?.Difficult > 0);
      setData(sortByKey(mapped,"Subject"));
    }
  };

  return { data, loading, fetchData };
}